import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import {
  Form,
  Input,
  Button,
  Typography,
  message,
  Card,
  Row,
  Col,
  Checkbox,
} from "antd";
import "./Login.css"; // Importar estilos propios
import megatrackLogo from "../assets/logo.png"; // Importar el logo

const { Text, Link } = Typography;

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    try {
      setLoading(true);
      const response = await login(values);
      console.log("Respuesta completa:", response);
      const { user } = response;

      message.success("¡Login exitoso!");

      // Redirigir según el rol
      const redirectPath = {
        ADMIN: "/admin",
        CLIENT_ADMIN: "/client-dashboard",
        CLIENT_USER: "/client-user-dashboard",
      }[user.role];

      if (redirectPath) {
        navigate(redirectPath);
      } else {
        message.error("Rol de usuario no reconocido");
      }
    } catch (error) {
      console.error("Error detallado:", error.response?.data || error.message);
      message.error("Credenciales inválidas");
    } finally {
      setLoading(false);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Error al enviar formulario:", errorInfo);
  };

  return (
    <div className="login-container">
      <Row className="login-row">
        {/* Columna izquierda: Formulario de login (35% en escritorio) */}
        <Col xs={24} md={6} className="login-form-col">
          <div className="login-form-wrapper">
            <Card className="login-card">
              <div className="logo-container">
                <img
                  src={megatrackLogo || "https://via.placeholder.com/150"}
                  alt="Megatrack Logo"
                  className="login-logo"
                />
              </div>

              <Form
                layout="vertical"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
              >
                <Form.Item
                  label="Correo"
                  name="email"
                  rules={[{ required: true, message: "Ingresa tu email" }]}
                >
                  <Input placeholder="usuario@turastreo.com" />
                </Form.Item>

                <Form.Item
                  label="Contraseña"
                  name="password"
                  rules={[{ required: true, message: "Ingresa tu contraseña" }]}
                >
                  <Input.Password placeholder="********" />
                </Form.Item>

                <Form.Item>
                  <Row justify="space-between">
                    <Col>
                      <Form.Item
                        name="remember"
                        valuePropName="checked"
                        noStyle
                      >
                        <Checkbox>Recordarme</Checkbox>
                      </Form.Item>
                    </Col>
                    <Col>
                      <Link
                        style={{ fontSize: 12 }}
                        onClick={() =>
                          message.info("Funcionalidad en desarrollo.")
                        }
                      >
                        ¿Olvidaste tu contraseña?
                      </Link>
                    </Col>
                  </Row>
                </Form.Item>

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    block
                  >
                    Acceder
                  </Button>
                </Form.Item>
              </Form>
            </Card>

            <div className="login-footer">
              <Text>
                Dashboard Ayasa ©2025 Service by <b>Tu Rastreo</b>
              </Text>
            </div>
          </div>
        </Col>

        {/* Columna derecha: Imagen de fondo (65% en escritorio) */}
        <Col xs={0} md={18} className="login-image-col">
          {/* La imagen de fondo y su overlay se establecen vía CSS */}
        </Col>
      </Row>
    </div>
  );
};

export default Login;
